import { MouseEvent, ChangeEvent, MutableRefObject } from 'react';
import { DropdownProps } from 'reactstrap';
import { FieldProps } from 'formik';
import { SelectOption } from '@minecraft.typings';

export enum DropdownTogglerTypeEnum {
  button = 'button',
  input = 'input',
}

export enum SelectionsResultTypeEnum {
  jsxElement = 'jsxElement',
  pill = 'pill',
}

export interface DropdownWithChildrenProps {
  withFormik?: boolean;
  withSearch?: boolean;
  withSelectAll?: boolean;
  withAutocomplete?: boolean;
  withSelectionsResult?: boolean;
  withSeeMoreButton?: boolean;
  showDropdownCloseButton?: boolean;
  heightDropdownAuto?: boolean;
  isFullWidth?: boolean;
  isLoading?: boolean;
  isMultipleSelect?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  isCollapsable?: boolean;
  isChildrensContentFilled?: boolean;
  isInitFetch?: boolean;
  placeholder?: string;
  dropdownPositionFixed?: boolean;
  dropdownDirection?: DropdownProps['direction'];
  dropdownTogglerType?: DropdownTogglerTypeEnum;
  selectionsResultType?: SelectionsResultTypeEnum;
  selectionsLimit?: number;
  initialOffset?: number;
  initialLimit?: number;
  name?: string;
  id?: string;
  maxSelectionsResultLength?: number;
  optionsTotalCount?: number;
  options?: SelectOption[];
  initialSelectedOptions?: SelectOption[];
  initialDisabledOptions?: SelectOption[];
  onOptionsChange?: (selectedItems: SelectOption[] | SelectOption) => void;
  onOptionsFetch?: (searchValue?: string, offset?: number, limit?: number) => void;
  onOptionsFetchMore?: (searchValue?: string, offset?: number, limit?: number) => Promise<void>;
  toggleLabel?: string;
  dataTestId?: string;
  children?: JSX.Element;
  qaId?: string;
  className?: string;
  onBlur?: () => void;
}

export type DropdownWithChildrenProviderType = Partial<DropdownWithChildrenProps> & {
  isInitialSelectedOptionsArray: boolean;
  formikSelectedOptions?: SelectOption[];
  form?: FieldProps['form'];
  setFieldTouched: FieldProps['form']['setFieldTouched'];
  setFieldValue: FieldProps['form']['setFieldValue'];
  validateField: FieldProps['form']['validateField'];
};

export type DropdownWithChildrenContextType = {
  isDropdownOpen: boolean;
  isSomeDropdownOptionsSelected: boolean;
  isSomeOptionsWithFieldName: boolean;
  isSelectionsResultExist: boolean;
  areAllOptionsSelected: boolean;
  areAllOptionsDisabled: boolean;
  searchInputValue: string;
  selectionsResult: string;
  currentSelectedOptions: SelectOption[];
  disabledOptions: SelectOption[];
  collapsedParentOptions: SelectOption[];
  toggleDropdown: () => void;
  toggleSelectAll: () => void;
  handleSearchInputValueChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleSearchInputValueClear: () => void;
  toggleParentOptions: (parentItem: SelectOption) => void;
  handleDropdownItemSelect: (newOptions: SelectOption[]) => void;
  handleSelectedOptionsClear: (event: MouseEvent<HTMLDivElement>) => void;
  togglerRef: MutableRefObject<HTMLInputElement>;
};
